import { render, staticRenderFns } from "./MerchantTerminalDetails.vue?vue&type=template&id=187e523f&"
import script from "./MerchantTerminalDetails.vue?vue&type=script&lang=js&"
export * from "./MerchantTerminalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports